import React from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { doChangeBlogIndexInView } from "../interactiveMapPage/ducks";
import MobileNav from "./MobileNav";

const actions = {
  changeBlogIndexInView: doChangeBlogIndexInView
};

function Nav({ changeBlogIndexInView }) {
  const resetBlogIndexInView = () => {
    window.scrollTo(0, 0);
    changeBlogIndexInView(1);
  };
  return (
    <Container onClick={resetBlogIndexInView}>
      <MobileNav />
    </Container>
  );
}

export default connect(
  null,
  actions
)(Nav);

const Container = styled.div`
  font-size: 18px;
  display: flex;
  flex-direction: row;
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  top: 0.5em;
  right: 0;
  z-index: 1000;
  text-transform: lowercase;
  border-radius: 20px 0 0 20px;
`;

const Option = styled(Link)`
  margin: 0.5em 1em;
  box-sizing: border-box;
  text-decoration: none;
  color: black;
  &:hover {
    border-bottom: 1px solid black;
    cursor: pointer;
  }
`;
